/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
var geoshipping_httpRequest = new XMLHttpRequest();
var geoshippingbar_url = "https://nohanabil.com/apps/GeoShippingBar/geoShippingBarProxy";
geoshipping_httpRequest.open("GET", geoshippingbar_url, true);    // async
    geoshipping_httpRequest.setRequestHeader("Accept", "text/javascript");

geoshipping_httpRequest.onreadystatechange = function () {
    if (geoshipping_httpRequest.status == 200 && geoshipping_httpRequest.readyState == 4) {
        var scripttagcreate = document.createElement("script");
        scripttagcreate.innerHTML = geoshipping_httpRequest.responseText;
        $m("head").append(scripttagcreate);
    }
};
geoshipping_httpRequest.send(null);